module.exports = __webpack_public_path__ + "img/gonggao1.f8f2fc1a.png";